
import CircularProgress from "./CircularProgress"
import { FaExternalLinkAlt } from "react-icons/fa";

// const calcScoreDistribution = (strand = {}) => {
//   const {
//     ipStrands = []
//   } = strand;

//   const scoreMap = { '1': 0, '2': 0, '-1': 0, '-2': 0}

//   ipStrands.forEach(({ score_distribution = {}, instances = [] }) => {
//     Object.keys(score_distribution).forEach(key => {
//       const val = score_distribution[key]
//       scoreMap[key] += val;
//     });
//   });

//   const weightMap = { '1': 75, '2': 100, '-1': 50, '-2': 25 }
//   let total = 0;
//   let totalWeighted = 0;
//   Object.keys(scoreMap).forEach(key => {
//     const val = scoreMap[key]
//     total += val;

//     const weightedVal = val * weightMap[key]

//     totalWeighted += weightedVal;
//   });

//   const finalPercentage = ( totalWeighted / (total * 100) ) * 100;

//   return finalPercentage;
// }

const skillDisplayNameMap = {
  'Critical_Thinking': 'Critical Thinking',
  'Creative_Thinking': 'Creative Thinking',
  'Resilience': 'Resilience',
}

const scoreDisplay = (score) => {
  return score; 
  // Boost logic below no longer using
  // const scoreNumber = Number(score)
  // const scoreBoost = Math.round(scoreNumber * 0.4);
  // const scoreTotal = scoreNumber + scoreBoost;
  // const finalScore = scoreTotal >= 100 ? 100 : scoreTotal;
  // return finalScore;
}

const getScoreBackgroundColorOrig = (score) => {
  return Number(score) >= 70 ? '#d3f5e7' : Number(score) >= 50 ?  '#fcf4c7' : Number(score) >= 1 ? '#ffc0cb' : '#dcdcdc'
}

const getScoreColorOrig = (score) => {
  return Number(score) >= 70 ? '#018a53' : Number(score) >= 50 ? '#a68d00' : '#4a0000'
}

const getScoreBackgroundColor = (score, skillName) => {
  if (Number(score) < 1) {
    return '#dcdcdc'
  }

  if (skillName === 'Critical Thinking') {
    return '#ACA7FF'
  } else if (skillName === 'Creative Thinking') { 
    return '#ACA7FF'
  } else if (skillName === 'Communication') { 
    return '#FCA625'
  } else if (skillName === 'Collaboration') {
    return '#FCA625'
  } else if (skillName === 'Resilience') {
    return '#01EFC4'
  } else {
    // fallback to original algorithm
    return getScoreBackgroundColorOrig(score)
  }
}

const getScoreColor = (score, skillName) => {
  if (Number(score) < 1) {
    return '#000000'
  }

  if (skillName === 'Critical Thinking') {
    return '#444182'
  } else if (skillName === 'Creative Thinking') { 
    return '#444182'
  } else if (skillName === 'Communication') { 
    return '#9E6D28'
  } else if (skillName === 'Collaboration') {
    return '#9E6D28'
  } else if (skillName === 'Resilience') {
    return '#1D6E5E'
  } else {
    // fallback to original algorithm
    return getScoreColorOrig(score)
  }
}

export default ({
  skillName = '',
  score: scoreRaw = '', // percent
  subSkills = [],
  hideOverall,
  onStrandClick
}) => {
  const score = scoreDisplay(scoreRaw)
  const scoreBackgroundColor = getScoreBackgroundColor(score, skillName)
  const scoreColor = getScoreColor(score, skillName)

  const conditionalSkillNameStyle = subSkills.length > 0 ? {} : { alignItems: 'center', justifyContent: 'center' }

  return (
    <div style={{
        display: 'flex',
        flexDirection: 'row',
        border: "1px solid #C2C9D1",
        borderRadius: "20px",
        overflow: 'hidden',
        background: '#ffffff',
        flex: '0 1 calc(50% - 10px)', // need to subtract have the gap from the parent container
        // flex: '1 1 calc(50% - 10px)', // use if we decide to have the leftover cards stretch the full container width
        boxSizing: 'border-box'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        ...conditionalSkillNameStyle,
        // borderRight: "1px solid #C2C9D1",
    }}>
        <div style={{
          fontSize: '22px', 
          fontWeight: 'bold', 
          color: '#565656',
          padding: 20,
          borderBottom: subSkills.length > 0 ? "1px solid #C2C9D1" : 'none',
        }}>
          {skillName}
        </div>
        {
          subSkills.length > 0 &&
          <div style={{
            padding: '20px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            color: '#565656',
          }}>
            {
              subSkills.map((strandObj) => {
                const { strand_name = '', score_percentage = '', skill_name = '', } = strandObj;
                const skillName = skillDisplayNameMap[skill_name] || skill_name;
                // const score_percentage = calcScoreDistribution(strandObj)
                const scoreRaw = Math.round(score_percentage)
                const score = scoreDisplay(scoreRaw)
                const subScoreBackgroundColor = getScoreBackgroundColor(score, skillName)
                const subScoreColor = getScoreColor(score, skillName)
                return (
                  <div
                    key={strand_name}
                    onClick={() => {
                      if (onStrandClick) {
                        onStrandClick(strandObj)
                      }
                    }}
                    style={{
                      flex: '0 1 calc(50% - 10px)',
                      boxSizing: 'border-box',
                      display: 'flex',
                      borderBottom: "1px solid #C2C9D1",
                      paddingBottom: '5px',
                      alignItems: 'center',
                      cursor: Boolean(onStrandClick) ? 'pointer' : 'default'
                  }}>
                    <div style={{ wordBreak: 'break-word', marginRight: '5px' }}>
                      {strand_name}
                    </div>
                    <div style={{ fontSize: '11px', position: 'relative', top: '2px' }}>
                      <FaExternalLinkAlt />
                    </div>
                    <div style={{ flex: 1 }}>
                      &nbsp;
                    </div>
                    <div style={{
                      background: subScoreBackgroundColor,
                      borderRadius: '50px',
                      padding: '5px 10px',
                    }}>
                      <CircularProgress percentage={Number(score)} size={25} color={subScoreColor} direction='row' />
                    </div>
                  </div>
                )
              })
            }
          </div>
        }
      </div>
      {
        !hideOverall &&
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100px',
          padding: '20px',
          boxSizing: 'border-box',
          textAlign: 'center',
          background: scoreBackgroundColor,
          color: scoreColor,
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
          fontSize: '28px'
        }}>
          <CircularProgress percentage={Number(score)} size={50} color={scoreColor} />
        </div>
      }
    </div>
  )
}